import { render, staticRenderFns } from "./exchrate.vue?vue&type=template&id=5cf4e4c4"
import script from "./exchrate.vue?vue&type=script&lang=js"
export * from "./exchrate.vue?vue&type=script&lang=js"
import style0 from "./exchrate.vue?vue&type=style&index=0&id=5cf4e4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports